const text = {
  pleaseAllowLocation:
    'Please, allow your location on this site before continue. If you have already allowed, please wait for a few moments.',
  reload: 'reload',
}
export default text
